import { EventsExtension } from '@remirror/extension-events';
import { useExtensionEvent } from '@remirror/react-core';

/**
 * A hook for subscribing to events from the editor.
 */

function useEvent(event, handler) {
  useExtensionEvent(EventsExtension, event, handler);
}
/**
 * @deprecated prefer `useEvent`
 */

var useEvents = useEvent;

export { useEvent, useEvents };
